import { render } from "./StoreDashboard.vue?vue&type=template&id=cb2c223a"
import script from "./StoreDashboard.vue?vue&type=script&lang=js"
export * from "./StoreDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/ravanjeyhan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__